module.exports = __webpack_public_path__ + "static/1-0a3250e1ce2ef76589ed3e165932292c.png";